import React from 'react';
import MarkSC from './mark.styled';
import PropTypes from 'prop-types';

const Mark = ({ children, colorStyle, size, ...rest }) => {
  return (
    <MarkSC colorStyle={colorStyle} size={size} {...rest}>
      {children}
    </MarkSC>
  );
};

Mark.propTypes = {
  colorStyle: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  size: PropTypes.oneOf(['default', 'small']),
};

Mark.defaultProps = {
  colorStyle: '',
  children: '',
  size: 'default',
};

export default Mark;
